import { useState } from 'react';

export interface FaqItem {
  question: string;
  answer: string;
}

interface FaqSectionProps {
  heading?: string;
  items: FaqItem[];
}

export default function FaqSection({
  heading = 'Frequently Asked Questions',
  items,
}: FaqSectionProps) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="py-16 bg-white">
      <div className="max-w-3xl mx-auto px-6">
        <h2 className="text-navy-900 text-3xl md:text-4xl font-display font-bold mb-8 text-center">
          {heading}
        </h2>
        <div className="space-y-3">
          {items.map((item, i) => (
            <div
              key={i}
              className="border border-navy-100 rounded-xl overflow-hidden shadow-sm"
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-navy-50 transition-colors"
              >
                <span className="text-navy-900 font-bold text-base md:text-lg pr-4">
                  {item.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-teal-500 text-2xl transition-transform ${
                    open === i ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {open === i && (
                <div className="px-6 pb-5 text-navy-600 text-base leading-relaxed">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
